module.exports = __webpack_public_path__ + "img/create-orbit-background.2c3c99ba.png";